// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NoChatsPlaceholder_root__smYBt {
  max-height: 100%;
  overflow-y: scroll;
  flex-grow: 1;
  width: 100%;
}
.NoChatsPlaceholder_root__smYBt > * {
  flex-shrink: 0;
}

.NoChatsPlaceholder_content__wQah0 {
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.NoChatsPlaceholder_icon__MNHjB {
  min-height: 100px;
}
.NoChatsPlaceholder_icon__MNHjB > svg {
  height: 100%;
}

.NoChatsPlaceholder_label__HybH6 {
  margin-top: 32px;
  color: #272A36;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}`, "",{"version":3,"sources":["webpack://./src/components/chats/ui/NoChatsPlaceholder/NoChatsPlaceholder.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,kBAAA;EACA,YAAA;EAEA,WAAA;AAAF;AAEE;EACE,cAAA;AAAJ;;AAIA;EACE,gBAAA;EAEA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AAFF;;AAKA;EACE,iBAAA;AAFF;AAIE;EACE,YAAA;AAFJ;;AAMA;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAHF","sourcesContent":[".root {\n  max-height: 100%;\n  overflow-y: scroll;\n  flex-grow: 1;\n\n  width: 100%;\n\n  &>* {\n    flex-shrink: 0;\n  }\n}\n\n.content {\n  min-height: 100%;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n}\n\n.icon {\n  min-height: 100px;\n\n  &>svg {\n    height: 100%;\n  }\n}\n\n.label {\n  margin-top: 32px;\n  color: #272A36;\n  text-align: center;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `NoChatsPlaceholder_root__smYBt`,
	"content": `NoChatsPlaceholder_content__wQah0`,
	"icon": `NoChatsPlaceholder_icon__MNHjB`,
	"label": `NoChatsPlaceholder_label__HybH6`
};
export default ___CSS_LOADER_EXPORT___;
